<template>
  <div class="congrats-component" ref="reachedGoal" :class="{'_show': show}">
    <div class="bg"></div>

    <div class="content">
      <div class="congratulations-img"></div>
      <div class="amount" v-if="info">
        {{ info.goal_to_reach | numFormat('$') }}
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "ReachedGoalModal",
        props: ["data"],
        data() {
            return {
                info: null,
                show: false,
            };
        },
        computed: {
          board() {
            return this.$store.state.boards.active ? this.$store.state.boards.boards[this.$store.state.boards.active] : null;
          },
        },
        methods: {
            open(data) {
                const accessor = "reached_goal_" + (this.board?.type || 'default');
                const reachedGoal = sessionStorage.getItem(accessor);
                
                if (reachedGoal == 'true') {
                  return;
                }

                this.info = data;
                this.show = true;

                sessionStorage.setItem(accessor, true);

                setTimeout(() => {
                    this.show = false
                }, 7000);
            },
        },
    };
</script>

<style lang="scss">
  .congrats-component {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    z-index: 100;
    transform: translateY(-100%);
    transition: transform 0.4s ease-in 0s, visibility 0s linear 0.5s;

    &._show {
      visibility: visible;
      transform: translateY(0%);
      transition: transform 0.4s ease-out 0s;
    }

    .bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url("https://s3.amazonaws.com/canadian-visa-media/agent-sales/congrats.gif");
        background-repeat: repeat;
        background-size: cover;
        filter: blur(4px);
      }
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #0004;
      }
    }

    .congratulations-img {
      width: 814px;
      height: 235px;
      background-image: url("https://s3.amazonaws.com/canadian-visa-media/agent-sales/congrant.png");
      background-repeat: repeat;
      background-size: contain;
      margin: 0 0 60px;
    }

    .content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
    .amount {
      font-size: 90px;
      line-height: 1;
      color: #75ba2e;
      font-weight: 700;
      animation: leaves 2s infinite alternate;
      text-rendering: optimizeLegibility;
    }
  }

  @keyframes scale {
    0% {
      transform: matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1);
    }
    100% {
      transform: matrix3d(1.3,0,0.00,0,0.00,1.3,0.00,0,0,0,1,0,0,0,0,1);
    }
  }

  @keyframes leaves {
    0% {
      transform: matrix3d(2.65,0,0.00,0,0.00,2.65,0.00,0,0,0,1,0,0,0,0,1);
      color: #75ba2e;
    }
    100% {
      transform: matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1);
      color: white;
    }
  }
</style>
